import { useNavigate } from "react-router-dom";
import useTimeOut from "../common/hook/useTimeOut";
import { ReactComponent as LogoSVG } from "../assets/icons/eliteVacances.svg";

const InactiveUser = () => {
  const navigate = useNavigate();

  useTimeOut(() => redirect(), 15000);

  const redirect = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <div className="card-afiliado ">
      <div className="card-afiliado-text">
        <div className="pt-4 p-1">
          <h5 className="text-center text-center title-alianza-plus">
            Tu membresía presenta una novedad
          </h5>
          <div className="desc">
            <p>
              Estimado cliente Agradecemos contactarse en Bogotá a nuestras
              líneas de atención de lunes a viernes de 8:00 am a 6:00 pm y
              sábados de 9:00 am a 3:00 pm.
            </p>
            <p>
              lineas:
              <a className="text-cta-user-inactive" href="tel:+576017945996">
                +57(601)7945996
              </a>
            </p>
            <p>
              <a
                className="text-cta-user-inactive"
                href="mailto:sac@elitevacances.com"
              >
                sac@elitevacances.com{" "}
              </a>
              <a
                className="text-cta-user-inactive"
                href="mailto:reservas@elitevacances.com"
              >
                reservas@elitevacances.com
              </a>
            </p>

            <section className="centrar flex-column">
              <p className="text-italic mt-4 text-center text-dark">
                Activa todos los beneficios que tenemos para ti
              </p>

              <LogoSVG />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InactiveUser;
